const params = new URLSearchParams(window.location.search);
const model = params.get('model');

export const isChair = model === 'chair';

export const RENDERER_CONFIG = {
	SCENE_BACKGROUND: 0xf0f0f0,
	HELPERS_COLOR: 0x060606,
	LIGHTS_COLOR: 0xf5f5f5,
	CONTROLS: {
		PAN_SPEED: 0.8,
		MAX_POLAR_ANGLE: Math.PI / 2.5,
		SCREEN_SPACE_PANNING: false,
		ROTATE_SPEED: 10,
		ROTATE_TIME: 500,
	},
	ZOOM_TICK: 0.25,
	MAX_ZOOM: {
		IN: 2,
		OUT: 0.5,
	},
	INITIAL_ZOOM: 1,
	DRACO_DECODER_PATH: 'https://www.gstatic.com/draco/versioned/decoders/1.5.7/',
} as const;
